'use client';
import React from 'react';

import { Breadcrumbs } from '../../../../components/breadcrumbs';
import { EditorialPage } from '../../../../components/page-components/editorial-page/editorial-page';
import useGetMobileAppWebViewHeader from '../../../../hooks/use-get-mobile-app-web-view';
import { IMeetingPlacePageLegalDocument } from '@/lib/fragments/meetingPlacePageLegalDocument';
import { IMeetingplacePageHomeMinified } from '@/lib/fragments/meetingPlacePageHome-minified';
import { GtmPageView } from '@/components/page-components/analytics/gtm-page-view';

interface MeetingPlacePageLegalDocumentProps {
  metaData: any;
  node_locale: string;
  preview: boolean;
  legalDocumentData: {
    meetingPlacePageLegalDocument: IMeetingPlacePageLegalDocument & {
      mainBlockCollection?: {
        items: any[];
      };
      blocksCollection?: {
        items: any[];
      };
    };
    meetingPlacePageHomeCollection: {
      items: IMeetingplacePageHomeMinified[];
    };
  } | null;
}

const MeetingPlacePageLegalDocument = ({
  metaData,
  node_locale,
  preview,
  legalDocumentData,
}: MeetingPlacePageLegalDocumentProps) => {
  const page = legalDocumentData?.meetingPlacePageLegalDocument;
  const homepage = legalDocumentData?.meetingPlacePageHomeCollection?.items[0];

  const isWebView = useGetMobileAppWebViewHeader();

  return (
    <>
      {/* ✅ GTM PAGE VIEW */}
      <GtmPageView
        homepage={homepage}
        language={node_locale}
        pageTitle={page?.name ?? ''}
      />
      <main className="bg-background-primary-light px-6 lg:-ml-22 lg:bg-transparent lg:px-0">
        <Breadcrumbs
          breadcrumbs={page?.name ? [page.name] : []}
          homeText={homepage?.breadcrumbHomeText || ''}
          cssClass={`lg:ml-22 ${isWebView ? '!pt-8' : ''}`}
          node_locale={node_locale}
        />
        {page && (
          <EditorialPage
            page={page}
            integrationId={homepage?.meetingPlace?.integrationId}
            node_locale={node_locale}
            showSocialShare={homepage?.meetingPlace?.showSocialShare ?? false}
          />
        )}
      </main>
    </>
  );
};
export default MeetingPlacePageLegalDocument;
